import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FadeInSection from '@/components/base/FadeInSection';
import MissionValuesSection from '@/pages/home/components/MissionValuesSection';
import ApproachSection from '@/pages/home/components/ApproachSection';
import StayConnectedSection from '@/pages/home/components/StayConnectedSection';

export default function About() {
  return (
    <main>
      <Navbar />
      <div className="pt-14">
        <FadeInSection>
          <MissionValuesSection />
        </FadeInSection>
        <FadeInSection>
          <ApproachSection />
        </FadeInSection>
        <FadeInSection>
          <StayConnectedSection />
        </FadeInSection>
      </div>
      <Footer />
    </main>
  );
}